(function () {
    'use strict';

    angular
        .module('elogbooks.admin.roles')
        .controller('RolesController', RolesController);

    RolesController.$inject = [
        'roleCollectionResponse',
        '$stateParams',
        '$state',
        '$filter',
        'filterPermissions',
        'operativePermissions',
        'sitePermissions',
        'userPermissions',
        'reportPermissions',
        '$translate'
    ];

    function RolesController (
        roleCollectionResponse,
        $stateParams,
        $state,
        $filter,
        filterPermissions,
        operativePermissions,
        sitePermissions,
        userPermissions,
        reportPermissions,
        $translate
    ) {
        var vm = this;
            vm.roleCollectionResponse = roleCollectionResponse;

        const permissionArrays = [
            { name: 'USER', array: userPermissions.getAll() },
            { name: 'SITE', array: sitePermissions.getAll() },
            { name: 'OPERATIVE', array: operativePermissions.getAll() },
            { name: 'REPORT', array: reportPermissions.getAll() }
        ];

        vm.roles = roleCollectionResponse.getData().roleAccesses;
        const allowedPermissions = permissionArrays.flatMap(permissionSet => permissionSet.array);

        for (var i = 0, rolesLength = vm.roles.length; i < rolesLength; i++) {
            vm.roles[i].permissions = filterPermissions.filterAllowedPermissions(vm.roles[i].permissions, allowedPermissions);
            vm.roles[i].groupedPermissions = groupedPermissions(vm.roles[i].permissions, permissionArrays);
        }

        vm.order = order;
        vm.search = search;

        vm.criteria = {
            id: { type: 'number', value: $stateParams.id ? parseInt($stateParams.id, 10) : null, title: 'ID', min: 1 },
            name: { type: 'text', value: $stateParams.name, title: 'NAME' }
        };

        function search(params) {
            var override = {
                page: "1"
            };

            $state.go('.', angular.extend({}, params, override), { reload: true });
        }

        function order(key) {
            $stateParams.order = key;
            $state.go('.', angular.extend({}, $stateParams), { reload: true });
        }

        function groupedPermissions(filteredPermissions, permissionArrays) {
            const filteredPermissionArrays = {};

            for (const permissionSet of permissionArrays) {
                filteredPermissionArrays[permissionSet.name] = permissionSet.array
                    .filter(permission => filteredPermissions.includes(permission))
                    .map(permission => $translate.instant(permission.toUpperCase()))
                    .sort((a, b) => a.localeCompare(b))
                    .join(', ');
            }

            return filteredPermissionArrays;
        }
    }
})();
